Input for the seekCandidateSummaries query.
